module.exports = __webpack_public_path__ + "dacbede58138562d01f8ee34ee916cc4.pdf";